"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageVariablesAsVariableGroup = exports.sendMessageVariablesAsResolvedVariables = exports.sendMessageVariablesAsUnresolvedVariables = exports.sendMessageVariables = void 0;
// This is the thing that was in utils.js
exports.sendMessageVariables = [
    // RECIPIENT VARIABLES
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'recipient_first_name',
        type: 'IUX',
        description: 'Recipient first name'
    },
    // Duplicate of `recipient_first_name`
    //
    // {
    //   variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'first_name',
    //   type: 'IUX',
    //   description: 'Recipient first name'
    // },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'recipient_last_name',
        type: 'IUX',
        description: 'Recipient last name'
    },
    // Duplicate of `recipient_last_name`
    //
    // {
    //   variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'last_name',
    //   type: 'IUX',
    //   description: 'Recipient last name'
    // },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'recipient_sms',
        type: 'IUX',
        description: 'Recipient mobile phone number'
    },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'recipient_voice',
        type: 'IUX',
        description: 'Recipient voice phone number'
    },
    // Not available on V5 API GET /contact API Request
    //
    // {
    //   variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'personal_address_primary',
    //   type: 'IUX',
    //   description: 'Recipient personal address'
    // },
    // Not available on V5 API GET /contact API Request
    //
    // {
    //   variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'personal_email_primary',
    //   type: 'IUX',
    //   description: 'Recipient personal email address'
    // },
    // Not available on V5 API GET /contact API Request
    //
    // {
    //   variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'personal_phone_primary',
    //   type: 'IUX',
    //   description: 'Recipient personal phone'
    // },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'recipient_email',
        type: 'IUX',
        description: 'Recipient current email address'
    },
    // Not available on V5 API GET /contact API Request
    //
    // {
    //   variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'work_address_primary',
    //   type: 'IUX',
    //   description: 'Recipient primary work address'
    // },
    // Not available on V5 API GET /contact API Request
    //
    // {
    //   variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'work_mobile_secondary',
    //   type: 'IUX',
    //   description: 'Recipient secondary work mobile'
    // },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'recipient_role',
        type: 'IUX',
        description: 'Recipient role'
    },
    // Not available on V5 API GET /contact API Request
    //
    // {
    //   variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'recipient_additionalrole',
    //   type: 'IUX',
    //   description: 'Recipient additional role'
    // },
    // SENDER VARIABLES
    // How can we get sender variables before sending a message?
    //
    // {
    //   variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'sender_full_name',
    //   type: 'IUX',
    //   description: 'Sender full name'
    // },
    // {
    //   variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'sender_first_name',
    //   type: 'IUX',
    //   description: 'Sender first name'
    // },
    // {
    //   variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'sender_last_name',
    //   type: 'IUX',
    //   description: 'Sender last name'
    // },
    // {
    //   variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'sender_sms',
    //   type: 'IUX',
    //   description: 'Sender SMS number'
    // },
    // {
    //   variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'sender_email',
    //   type: 'IUX',
    //   description: 'Message author email address'
    // },
    // DATE VARIABLES
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'date',
        type: 'IUX',
        description: 'Current date e.g: yyyy/mm/dd'
    },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'yy',
        type: 'IUX',
        description: 'Current year, short form e.g: 18'
    },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'yyyy',
        type: 'IUX',
        description: 'Current year, long form e.g: 2018)'
    },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'mm',
        type: 'IUX',
        description: 'Current month e.g: 06'
    },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'month',
        type: 'IUX',
        description: 'Month in spoken form e.g: June'
    },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'dd',
        type: 'IUX',
        description: 'Current day e.g: 08'
    },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'day',
        type: 'IUX',
        description: 'Day in spoken form e.g: Wednesday'
    },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'time',
        type: 'IUX',
        description: 'Current time in 24 -hour format'
    },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'short_hour',
        type: 'IUX',
        description: 'Current time in 12-hour format'
    },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'hrs',
        type: 'IUX',
        description: 'Current hour in 24-hour format e.g: 08)'
    },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'min',
        type: 'IUX',
        description: 'Current minute e.g: 07'
    },
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'sec',
        type: 'IUX',
        description: 'Current second e.g: 09'
    },
    // Removed in asbsence of distributionList lookup
    //
    // {
    //   variableId: 'f8daa77e-0fe2-11ea-9a9f-362b9e155667',
    //   variableName: 'distributionlistname',
    //   type: 'IUX',
    //   description: 'Distribution list name'
    // },
    // LINK VARIABLES
    {
        variableId: 'f8dad258-0fe2-11ea-9a9f-362b9e155667',
        variableName: 'web_link',
        type: 'IUX',
        description: 'Web content link'
    }
];
exports.sendMessageVariablesAsUnresolvedVariables = exports.sendMessageVariables.map(function (v) {
    return {
        id: v.variableName,
        label: v.description,
        valueType: 'string',
        inputType: 'system',
    };
});
exports.sendMessageVariablesAsResolvedVariables = exports.sendMessageVariables.map(function (v) {
    return {
        id: v.variableName,
        label: v.description,
        valueType: 'string',
        inputType: 'system',
        value: "@@" + v.variableName + "@@"
    };
});
exports.sendMessageVariablesAsVariableGroup = {
    groupName: 'System',
    groupType: 'systemVariables',
    variables: exports.sendMessageVariables.map(function (v) {
        return {
            variableId: v.variableName,
            variableName: v.description,
            type: 'IUX',
            groupName: 'System',
            groupType: 'systemVariables',
            inputType: 'system',
        };
    })
};
